import React from 'react'

const WaitingForInputIllustration = () => {
  return (
    <svg
      width="293"
      height="224"
      viewBox="0 0 420 330"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26111_36860)">
        <path
          d="M418.785 204.24C419.2 197.985 419.017 191.708 418.213 185.485C414.449 156.253 397.397 128.693 372.294 109.241C363.342 102.3 353.147 96.0878 347.325 86.9296C337.508 71.5053 338.251 53.778 326.071 38.5464C313.879 23.3042 296.108 11.4039 276.072 5.29843C216.316 -12.9109 132.664 16.7382 140.203 80.0422C140.227 80.2672 140.264 80.5992 140.288 81.0169C141.287 94.1705 129.558 105.225 114.613 105.535C59.4858 106.681 12.0323 144.064 1.87411 191.408C-4.6544 221.86 6.03969 255.237 31.362 276.777C50.2655 292.855 75.6366 301.692 101.02 307.755C151.908 319.923 205.452 322.472 257.923 317.823C307.033 313.464 358.847 301.049 390.601 267.823C407.555 250.096 417.263 227.366 418.785 204.24Z"
          fill="white"
        />
        <path
          d="M255.725 200.043H248.895C248.395 200.045 247.899 199.948 247.436 199.758C246.973 199.568 246.553 199.288 246.198 198.935C245.843 198.581 245.561 198.161 245.369 197.699C245.176 197.236 245.076 196.74 245.075 196.238L247.436 186.973L234.499 190.44L237.339 201.599C240.331 242.47 186.624 246.944 184.588 202.676L151.307 210.84V210.824L129.576 215.564L144.043 273.464L174.214 266.164C178.375 274.222 181.423 279.815 181.423 279.815H274.498L255.725 200.043Z"
          fill="#2E3860"
        />
        <path
          d="M118.594 277.947C155.316 265.723 219.791 253.119 219.791 253.119L152.898 212.721C152.898 212.721 136.603 215.295 120.707 219.108"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M79.2277 278.109C61.2537 275.017 66.3816 224.522 96.5975 179.904C110.14 157.848 114.036 151.855 124.444 148.423C128.516 147.083 132.876 147.086 137.505 149.137C153.963 156.434 171.454 164.028 159.74 167.364C148.026 170.701 120.38 193.476 120.38 193.476C120.38 193.476 120.642 223.058 119.182 233.841C118.247 240.664 116.639 247.378 114.38 253.883"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M172.862 142.256C172.048 154.632 173.889 170.108 175.752 180.159"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.891 155.975C241.151 156.27 248.136 157.897 246.999 166.426C246.006 173.889 239.38 173.839 235.164 173.009"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M233.06 184.752L237.35 201.605C240.255 241.385 189.409 246.686 184.852 206.073"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M225.499 157.797L237.045 158.74C237.045 158.74 233.404 183.016 231.856 189.572C230.309 196.129 229.09 199.084 221.001 205.635C212.913 212.187 195.02 216.155 185.828 206.723C176.637 197.29 174.482 178.068 174.482 178.068C178.604 176.54 189.133 175.642 189.133 175.642"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.659 159.759C237.659 159.759 243.139 148.386 244.752 139.019C246.268 130.216 241.66 121.376 233.403 118.022C226.491 115.204 224.243 116.12 224.243 116.12C224.243 116.12 228.349 108.805 217.675 98.0326C215.81 96.1483 213.582 94.6652 211.125 93.6741C208.669 92.683 206.037 92.2047 203.389 92.2684C190.331 92.616 186.267 103.673 186.267 103.673C186.267 103.673 172.343 77.8909 143.654 93.0505C140.764 94.5804 137.494 98.8568 135.925 101.74C126.413 119.199 157.556 139.994 173.794 141.676C191.62 143.519 202.819 141.297 208.268 136.562C204.17 139.404 211.457 165.581 237.659 159.759Z"
          fill="#2E3860"
        />
        <path
          d="M188.128 168.254L187.287 185.18L193.098 183.282"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M205.934 156.882C204.997 155.825 203.793 155.039 202.449 154.607C201.106 154.176 199.671 154.114 198.295 154.428"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M184.159 150.697C184.159 150.697 179.493 149.101 178.012 152.909"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M207.216 188.421C206.297 187.157 197.341 193.456 200.84 194.022C204.34 194.588 209.189 191.136 207.216 188.421Z"
          fill="#2E3860"
        />
        <path
          d="M169.659 187.263L203.689 175.734C203.689 175.734 208.242 173.996 208.082 168.077C207.922 162.157 200.495 159.943 200.495 159.943L164.227 154.811L169.659 187.263Z"
          fill="#004360"
        />
        <path
          d="M133.245 187.263L167.275 175.734C167.275 175.734 171.831 173.996 171.67 168.077C171.51 162.157 164.081 159.943 164.081 159.943L146.538 161.109L127.812 154.811L133.245 187.263Z"
          fill="#004360"
        />
        <path
          d="M163.846 188.315C173.112 188.315 180.622 180.787 180.622 171.5C180.622 162.212 173.112 154.684 163.846 154.684C154.581 154.684 147.07 162.212 147.07 171.5C147.07 180.787 154.581 188.315 163.846 188.315Z"
          fill="#2E3860"
        />
        <path
          d="M127.178 188.556C136.444 188.556 143.955 181.027 143.955 171.74C143.955 162.453 136.444 154.924 127.178 154.924C117.913 154.924 110.402 162.453 110.402 171.74C110.402 181.027 117.913 188.556 127.178 188.556Z"
          fill="#2E3860"
        />
        <path
          d="M139.666 145.803C146.417 141.023 159.395 139.414 162.206 139.833C164.904 140.236 163.338 144.705 155.27 147.169"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M143.75 147.049C151.894 145.048 166.287 152.642 168.604 154.862C171.087 157.232 164.354 160.971 151.715 153.617C151.715 153.617 148.011 151.11 145.019 151.394"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M135.992 147.397C144.369 145.629 158.858 152.972 161.198 155.131C163.74 157.461 158.123 159.871 145.181 152.642C145.181 152.642 140.891 148.685 137.83 148.964"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M126.803 148.035C134.476 144.348 150.8 152.899 153.283 155.274C155.766 157.649 149.032 161.38 136.394 154.028C136.394 154.028 132.69 151.521 129.7 151.806"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M351.058 123.012C357.146 121.185 364.228 120.071 372.459 119.947C372.459 119.947 375.587 131.607 371.764 146.18"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M350.95 148.027C352.514 139.743 352.568 131.234 351.106 122.93"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M351.107 122.93C348.62 108.631 341.467 92.5843 326.589 75.4023C326.589 75.4023 310.695 83.9683 298.863 102.183"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.271 180.966C286.271 180.966 271.877 121.885 226.652 136.015C226.652 136.015 227.809 149.002 234.209 161.977"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M317.012 135.104C311.734 116.613 298.787 96.1314 270.503 78.6992C270.503 78.6992 257.721 95.9997 252.683 120.03"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M269.146 144.012C270.849 134.651 275.623 123.865 285.392 111.797C285.392 111.797 351.563 142.532 318.384 184.009"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M303.539 184.043C310.039 174.095 333.462 143.196 371.736 146.651"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M371.726 146.643C377.156 147.151 382.517 148.26 387.715 149.95C387.715 149.95 378.223 172.393 356.359 186.149"
          stroke="#004360"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M344.569 249.82L355.125 201.563H361.49C361.988 201.564 362.482 201.474 362.943 201.298C363.404 201.122 363.823 200.863 364.176 200.535C364.53 200.208 364.81 199.819 365.002 199.391C365.194 198.963 365.293 198.503 365.294 198.039L365.584 190.504C365.584 190.039 365.486 189.579 365.294 189.15C365.103 188.72 364.823 188.331 364.469 188.003C364.116 187.675 363.696 187.415 363.235 187.238C362.773 187.061 362.279 186.971 361.78 186.973H251.037C250.538 186.971 250.044 187.062 249.583 187.239C249.122 187.416 248.702 187.675 248.349 188.003C247.996 188.331 247.716 188.721 247.525 189.15C247.334 189.579 247.235 190.039 247.235 190.504L246.945 198.039C246.946 198.503 247.045 198.962 247.237 199.39C247.429 199.818 247.709 200.207 248.062 200.535C248.415 200.862 248.834 201.121 249.295 201.297C249.755 201.474 250.249 201.564 250.747 201.563H257.555L276.697 281.379"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M325.561 244.773C322.529 240.423 320.21 235.783 323.115 234.54C327.111 232.831 327.056 237.144 333.08 241.263C339.103 245.381 344.746 246.153 350.72 253.639"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M325.764 245.416C315.479 239.817 300.545 239.493 296.961 239.654C294.776 239.751 294.024 241.608 295.679 243.949"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M320.924 251.232C310.5 245.747 295.65 243.693 291.862 243.991C288.725 244.238 288.688 248.265 293.701 252.294"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M318.447 258.239C308.927 253.97 297.859 251.961 294.636 252.138C291.187 252.327 291.058 257.649 297.36 262.539"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M317.995 265.314C309.94 261.962 301.923 260.122 299.343 260.432C294.262 261.043 298.502 270.141 322.616 277.398"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M322.623 277.399C372.232 290.963 368.998 247.907 326.083 245.221"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M390.453 280.59H29.4023"
          stroke="#2E3860"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_26111_36860">
          <rect width="419" height="320" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WaitingForInputIllustration
